import * as React from 'react';
import '../../../styles/IconButton.css';

interface Props {
    text?: string;
    icon: any;
    addlButtonClassName?: string;
    addlIconClassName?: string;
    disabled?: boolean;
    suppressBottomMargin?: boolean;
    removeBoldFont?: boolean;
    style?: React.CSSProperties;
    onClick?: (e?: React.SyntheticEvent<HTMLButtonElement>) => void;
}

const IconButton = (props: Props) => {
    return (
        <button
            className={`btn icon ${props.removeBoldFont ? '' : 'font-weight-bold'}${
                props.suppressBottomMargin ? '' : ' mb-4'
            } ${props.addlButtonClassName || 'btn-primary'}`}
            type={'button'}
            onClick={props.onClick}
            disabled={props.disabled}
        >
            <img src={props.icon} className={props.addlIconClassName} style={props.style ? { ...props.style } : {}} />
            {props.text || ''}
        </button>
    );
};

export default IconButton;



// WEBPACK FOOTER //
// ./src/components/common/form/IconButton.tsx